(function($) {
  $(document).ready(function() {
    var mySwiper = new Swiper('.swiper-gallery-container', {
      // Navigation arrows
      nextButton: '.swiper-button-next',
      prevButton: '.swiper-button-prev',
      slidesPerView: 4,
      spaceBetween: 30,

      breakpoints: {

        1024: {
          slidesPerView: 4,
          spaceBetween: 30,
        },
        768: {
          slidesPerView: 3,
          spaceBetween: 20,
        },
        425: {
          slidesPerView: 1,
        },
      },
    });
    var imageSwiper = new Swiper('.swiper-image-container', {
      // Navigation arrows
      nextButton: '.swiper-button-next',
      prevButton: '.swiper-button-prev',
      slidesPerView: 1,
      spaceBetween: 30,
    });
    $('img').unveil();
  });
  $(window).resize(function() {
    $('img').unveil();
  });

    if($('input[type="file"]').length > 0){
        $('input[type="file"]').change(function(e){

            var fileName = e.target.files[0].name;
            var $this = $(this);
            var fieldName = $this.attr('name');
            $('span.pdf_upload').html(fileName);
        });
    }

}(jQuery));

